import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'max'
})
export class MaxPipe implements PipeTransform {
  transform(items: any[], attr: string): number {
    const max = Math.max(...items);
    return max == -Infinity ? 0 : max;
  }
}

